import ReactSlider from 'react-slider';
import { useCalibration } from '../../context/calibrationContext';
import { Flex, Text, theme } from '../../2022-component-library';
import { useBreakpoints } from '../../helpers/useBreakpoints';
import ResponsiveButton from '../ResponsiveButton';
import styled from '@emotion/styled';

const BlindspotControl = ({ blindspotPosition, setBlindspotPosition, postMessage, messageContent, ...props }) => {
  const { sm } = useBreakpoints();

  const StyledBlindspotSlider = styled(ReactSlider)`
width: 100%;
& .blindspot-slider-thumb {
  width: 28px;
  height: 28px;
  border: 0;
  background: #000;
  cursor: pointer;
  border-radius: 50%;
  margin-top: 8px;
  ${({ smallScreen }) => smallScreen && `transform: translateY(-45%);`}
`;

  const {
    calibrationData: { circleDimensionsPx, screenWidthPx },
  } = useCalibration();

  const handleBlindspotMovement = (direction) => {
    if (direction === 'increment') {
      const incrementedValue = blindspotPosition + circleDimensionsPx;
      if (incrementedValue <= screenWidthPx - circleDimensionsPx) {
        setBlindspotPosition(incrementedValue);
      } else setBlindspotPosition(screenWidthPx - circleDimensionsPx);
    } else {
      const decrementedValue = blindspotPosition - circleDimensionsPx;
      if (decrementedValue >= 0) {
        setBlindspotPosition(decrementedValue);
      } else setBlindspotPosition(0);
    }
  };

  return (
    <Flex column centered width='100%'>
      <BlindspotSliderContainer smallScreen={props.smallScreen}>
        <StyledBlindspotSlider
          value={blindspotPosition}
          min={0}
          max={screenWidthPx - circleDimensionsPx || 500}
          {...props}
          thumbClassName='blindspot-slider-thumb'
        />
      </BlindspotSliderContainer>
      {sm && <Text marginTop='0.5rem'>{`Blindspot Position`}</Text>}
      <Flex marginTop={sm ? '0.75rem' : '1rem'} gap='1rem'>
        <ResponsiveButton
          height='3em'
          width={sm ? '5em' : '7em'}
          padding='0'
          onClick={() => handleBlindspotMovement('decrement')}
          disabled={blindspotPosition <= 0}
        >
          {'\u2b05'}
        </ResponsiveButton>
        <ResponsiveButton
          height={'3em'}
          width={sm ? '5em' : '7em'}
          padding='0'
          onClick={() => handleBlindspotMovement('increment')}
          disabled={blindspotPosition >= screenWidthPx - circleDimensionsPx}
        >
          <Text style={{ transform: 'rotate(180deg' }}>{'\u2b05'}</Text>
        </ResponsiveButton>
      </Flex>
    </Flex>
  );
};

export default BlindspotControl;

const BlindspotSliderContainer = styled(Flex)`
  width: 100%;
  height: 44px;
  cursor: pointer;
  border: 1px solid ${theme.colors.primary};
  border-radius: 12px;
  box-sizing: border-box;
  padding: 0px 10px;
  justify-content: center;

  ${({ smallScreen }) =>
    smallScreen &&
    `height: 15px;
  border: none;
  border-radius: 5px;
  padding: 0px 10px;
  background-color: ${theme.colors.primary};
  outline: none;
  -webkit-transition: 0.2s;
  transition: opacity 0.2s;`}
`;
